module.exports = __webpack_public_path__ + "img/3.3aa6f130.jpg";